// 校验删除文件

import { message } from 'ant-design-vue'
import Vue from 'vue'
//2.新创建一个vue实例
let checkVue = new Vue()

var vaildFile = {}

vaildFile.beforeFile = function(file, width, height, duration) {
  const isJPG = file.type
  if (
    isJPG !== 'image/jpeg' &&
    isJPG !== 'image/png' &&
    isJPG !== 'image/gif' &&
    isJPG !== 'video/mp4'
  ) {
    checkVue.$message.error('只能上传JPG、PNG、GIF、MP4模式素材')
    return false
  }
  if (isJPG == 'video/mp4') {
    // 视频大小校验
    const isLt30M = file.size / 1024 / 1024 < 30
    if (!isLt30M) {
      checkVue.$message.error('上传失败，文件大小超出最大限制')
    }
    return isLt30M && checkVideoWidthAndHeight(file, width, height, duration)
  } else {
    // 图片大小校验
    const isLt2M = file.size / 1024 / 1024 < 1
    if (!isLt2M) {
      checkVue.$message.error('上传失败，文件大小超出最大限制')
    }
    return isLt2M && checkWidthAndHeight(file, width, height)
  }
}

// 图片长宽校验
function checkWidthAndHeight(file, width, height) {
  let oThis = this
  return new Promise(function(resolve, reject) {
    let filereader = new FileReader()
    filereader.onload = e => {
      let src = e.target.result
      const image = new Image()
      image.onload = function() {
        if ((width && this.width != width) || (height && this.height != height)) {
          checkVue.$message.error(
            `上传失败，文件尺寸不符合规格！要求宽度：${width}，要求高度：${height}`
          )
          reject()
        } else {
          resolve()
        }
      }
      image.onerror = reject
      image.src = src
    }
    filereader.readAsDataURL(file)
  })
}

//视频宽高,时长检验
function checkVideoWidthAndHeight(file, width, height, duration) {
  return new Promise(function(resolve, reject) {
    let videoUrl = window.URL.createObjectURL(file)
    let videoObj = document.createElement('video')
    videoObj.src = videoUrl
    videoObj.onloadedmetadata = function(evt) {
      URL.revokeObjectURL(videoUrl)
      console.log(
        '视频宽度：',
        videoObj.videoWidth,
        '视频高度：',
        videoObj.videoHeight,
        '视频时长：',
        videoObj.duration
      )
      console.log('要求宽度：', width, '要求高度：', height, '要求时长：', duration)
      if (videoObj.videoWidth != width || Math.abs(videoObj.videoHeight - height) > 1) {
        checkVue.$message.error(
          `上传失败，文件尺寸不符合规格！要求宽度：${width}，要求高度：${height}`
        )
        reject()
      } else if (Math.abs(parseInt(videoObj.duration) - parseInt(duration)) > 0.5) {
        checkVue.$message.error(`上传失败，视频时长不符合规格！要求时长：${duration}s`)
        reject()
      } else {
        resolve()
      }
    }
    videoObj.load()
  })
}

export default vaildFile
